import {useScrollService} from '@/di/di.root-container.hooks';

import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export function ScrollToTop(): null {
  const {pathname} = useLocation();
  const scrollService = useScrollService();

  useEffect(() => {
    scrollService.scrollPageToTop();
  }, [pathname]);

  return null;
}
